const MAX_VIDEO_COUNT = 50;

export { MAX_VIDEO_COUNT };
